import React from 'react';
import ContentLoader from 'react-content-loader';
var StatusSkeleton = function StatusSkeleton() {
  return /*#__PURE__*/React.createElement(ContentLoader, {
    speed: 2,
    width: 600,
    height: 50,
    viewBox: "0 0 600 50",
    backgroundColor: "#f3f3f3",
    foregroundColor: "#ecebeb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "18",
    y: "10",
    rx: "3",
    ry: "3",
    width: "800",
    height: "11"
  }));
};
export default StatusSkeleton;